import { render, staticRenderFns } from "./JEllipsis.vue?vue&type=template&id=51aeca46&scoped=true&"
import script from "./JEllipsis.vue?vue&type=script&lang=js&"
export * from "./JEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aeca46",
  null
  
)

export default component.exports